// The one place where Source axes (X forward, Y left, Z up) become three.js axes (Y up, camera looks down -Z).
// three (x, y, z) = Source (-Y, Z, -X). Source yaw maps to a rotation about three's Y axis with the same
// sign; Source pitch (positive = down) is the negated rotation about three's X axis.

import * as THREE from 'three';

export function sourceToThree(out: THREE.Vector3, x: number, y: number, z: number): THREE.Vector3 {
  return out.set(-y, z, -x);
}

/** Box extents (always positive) along Source X, Y, Z, as three.js x, y, z extents. */
export function sizeToThree(out: THREE.Vector3, sx: number, sy: number, sz: number): THREE.Vector3 {
  return out.set(sy, sz, sx);
}

/** The same mapping as a matrix, for a group whose children are positioned in Source coordinates. */
export const SOURCE_TO_THREE = new THREE.Matrix4().set(0, -1, 0, 0, 0, 0, 1, 0, -1, 0, 0, 0, 0, 0, 0, 1);

/** Make `group` a Source-space container: children use Source units and axes. */
export function makeSourceSpace(group: THREE.Object3D) {
  group.matrixAutoUpdate = false;
  group.matrix.copy(SOURCE_TO_THREE);
  group.matrixWorldNeedsUpdate = true;
}

/** Source view angles (radians) to camera rotation. The camera must use rotation order 'YXZ'. */
export function applyViewAngles(camera: THREE.Camera, yaw: number, pitch: number) {
  camera.rotation.set(-pitch, yaw, 0);
}
